import { derived } from 'svelte/store';

import { sidePanelState } from '../ui/sidepanel';
import { drawerState } from './drawer-sidepanel';
import { showNewLayout } from './new_layout';

/** @deprecated Collapse into `sidePanelState` when single layout remains. */
export const sidePanelStateCombined = derived(
	[showNewLayout, sidePanelState, drawerState],
	([$showNewLayout, $sidePanelState, $drawerState]) =>
		$showNewLayout ? $sidePanelState : $drawerState,
);
